import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/ForgotPassword.css';

const popupContent = {
  reset: {
    title: 'Find Your Account',
    description: 'Please enter your email address or mobile number to search for your account.',
    placeholder: 'Email address or mobile number',
    inputId: 'identify_email',
    inputName: 'email',
    inputClassName: 'inputtext _9o1w',
    inputLabel: 'Email address or mobile number',
    submitLabel: 'Submit',
    emptyAlert: 'Please enter your email address or mobile number.',
    successAlert: (value) => `Password reset link has been sent to: ${value}`,
    closeAriaLabel: 'Close Find Your Account popup',
  },
  verify: {
    title: 'Verify Your Email',
    description: 'Enter your email address and we will send you a verification link.',
    placeholder: 'Enter your email address',
    inputId: 'verify_email_input',
    inputName: 'verify_email',
    inputClassName: 'verify-email-textbox',
    inputLabel: 'Email address',
    submitLabel: 'Verify',
    emptyAlert: 'Please enter your email address.',
    successAlert: (value) => `Verification link has been sent to: ${value}`,
    closeAriaLabel: 'Close Verify Your Email popup',
  },
};

const ForgotPassword = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const mode = pathname === '/verify-email' ? 'verify' : 'reset';
    const content = popupContent[mode];
    const [email, setEmail] = useState('');

    const handleClose = () => {
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);
        } else {
            navigate('/web-links');
        }
    };

    const handleClear = () => {
        setEmail('');
    };

    const handleSubmit = () => {
        if (!email) {
            alert(content.emptyAlert);
        } else {
            alert(content.successAlert(email));
        }
    };

    return (
        <div className="forgot-password-overlay" onClick={handleClose}>
            <div
                className="forgot-password-container"
                role="dialog"
                aria-modal="true"
                aria-labelledby="account-popup-title"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    type="button"
                    className="forgot-password-close"
                    onClick={handleClose}
                    aria-label={content.closeAriaLabel}
                    id="find-account-close"
                >
                    ×
                </button>
                <h2 className="uiHeaderTitle" id="account-popup-title">{content.title}</h2>
            <div className="_9nq2 marginBottom16px">
                {content.description}
            </div>
            <input
                type="text"
                className={content.inputClassName}
                id={content.inputId}
                name={content.inputName}
                placeholder={content.placeholder}
                autoFocus
                aria-label={content.inputLabel}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <div className="button-container">
                <button onClick={handleClear} className="clear-button">Clear</button>
                <button onClick={handleSubmit} className="submit-button">{content.submitLabel}</button>
            </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
